import reducers from '../reducers';
import { genericStoreSetup } from 'reactifi-local';

export default props => {
  return genericStoreSetup(reducers, {});
};
